module.exports = __webpack_public_path__ + "assets/img/logo.12b23cce.webp";